module.exports = __webpack_public_path__ + "img/Cypress 960x1080 v3.16b42f88.png";